


const GoogleMap = () => {
    return (
        <div className="map-area">
            <div className="maps">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d260.0781973116619!2d82.22927258686657!3d16.980252483521042!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a382921aeef6d3f%3A0xdaf6024983e8abd9!2sAdyanta%20Overseas%20Education%20Consultants!5e0!3m2!1sen!2sin!4v1791534436968!5m2!1sen!2sin"></iframe>
            </div>
        </div>
    );
}
 
export default GoogleMap;